import { uiTypeIs, rankWith } from '@jsonforms/core'

export default rankWith(
  5, // outranks @jsonforms/material-renderers' default Group renderer (effective rank 2)
  uiTypeIs('Group')
)
